import React from "react";
import { Grid } from "@mui/material";
import MessagesModal from "../../components/loginMessages/MessagesModal";
import ProfessionalStandardsTile from "../../components/dashboard/ProfessionalStandardsTile";
import ReportsTile from "../../components/dashboard/ReportsTile";
import SchoolSimsResearchTile from "../../components/dashboard/SchoolSimsResearchTile";
import GettingStartedSteps from "../../components/dashboard/GettingStartedSteps";
import SimulationLibraryTile from "../../components/dashboard/SimulationLibraryTile";
import UsageSnapshotTile from "../../components/dashboard/UsageSnapshotTile";
import DashboardSkeleton from "../../components/dashboard/DashboardSkeleton";
import Loader from "../../components/generic/Loader";
import { useClientAISummary } from "../../hooks/useClientAISummary";
import { useSimUsedCount } from "../../hooks/useSimUsedCount";
import { useUserMessages } from "../../hooks/useUserMessages";

const DashboardPage = () => {
  const { aiSummaryData, loading: aiSummaryLoading } = useClientAISummary();
  const { simUsedCount, loading: dashboardLoading } = useSimUsedCount();
  const {
    messages,
    open: messagesOpen,
    accountId,
    userId,
    handleClose: handleMessagesClose,
  } = useUserMessages();

  const loading = aiSummaryLoading || dashboardLoading;
  const hasSimUsage =
    Number(simUsedCount.totalCount) > 0 ||
    (simUsedCount.clientSims || []).length > 0;

  return (
    <>
      {loading ? (
        <>
          <DashboardSkeleton />
          <Loader loading />
        </>
      ) : (
        <Grid container spacing="16px">
          <Grid size={12}>
            <SimulationLibraryTile
              clientSims={simUsedCount.clientSims}
              globalSims={simUsedCount.globalSims}
              totalCount={simUsedCount.totalCount}
            />
          </Grid>

          {!hasSimUsage ? (
            <Grid size={12}>
              <GettingStartedSteps />
            </Grid>
          ) : null}

          <Grid size={12}>
            <UsageSnapshotTile aiSummaryData={aiSummaryData} />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <ProfessionalStandardsTile
              showOnlyProfessionalStandardsReport={
                simUsedCount.showOnlyProfessionalStandardsReport
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <SchoolSimsResearchTile />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <ReportsTile hasSimUsage={hasSimUsage} />
          </Grid>
        </Grid>
      )}
      <MessagesModal
        open={messagesOpen}
        handleClose={handleMessagesClose}
        accountId={accountId}
        userId={userId}
        messages={messages}
      />
    </>
  );
};

export default DashboardPage;
